/**
 * Desc: 物业维修列表
 */

import React, {Component} from 'react'
import {Button, List, Skeleton} from 'antd'
import './ManagementList.css'
import {getIntValue, getStrValue, isObjEmpty} from "../../../utils/common";
import {fetchGet, fetchPost} from "../../../utils/fetchRequest";
import {_baseURL, API} from "../../../configs/api.config";
import {Toast, Modal, SearchBar, DatePicker} from "antd-mobile";
import {connect} from 'react-redux'
import UploadEnclosure from "../../../components/UploadEnclosure";
import TargetSelect from "../../../components/TargetSelect";
import moment from "moment";
import ImagesViewer from "../../../components/imagesVIewer";

const mPageSize = 10;
let mPageIndex = 0;
let mSearchKey = '';
const alert = Modal.alert;

class ManagementDetail extends Component {

    constructor() {
        super();

        this.state = {
            targetData: [],
            maDetailsList: {}, // 详情对象
            isLoading: true,
            isRefreshing: false,
            searchKey: '',
            repairDetails: null, // 维修详情
            fileList: [], //附件
            scrapTime: null, // 完成日期
            repairHr: [], //维修人员
            imageMaList:"[]",
            imageMiList:"[]",
            previewVisible0: false,
            previewVisible1: false,
        }
    }

    componentDidMount() {
        document.title = '物业维修';

        // this.title = this.props.match.params.classTitle;
        this.mType = this.props.match.params.type;
        if (this.props.match.params.maId) {
            this.maId = this.props.match.params.maId;
        }

        Toast.loading('', 0);
        mPageIndex = 0;
        this.loadPhones()

    }

    componentWillUnmount() {
        Toast.hide()
    }

    onClickImage0() {
        this.setState({
            previewVisible0: true
        })
    }

    handleCancel0 = () => this.setState({previewVisible0: false});

    onClickImage1() {
        this.setState({
            previewVisible1: true
        })
    }

    handleCancel1 = () => this.setState({previewVisible1: false});

    render() {

        const targetProps = {
            targetData: this.state.targetData,
            targetValues: this.state.targetList,
            title: '维修人员',
            targetCount: this.state.targetCount,
            onTargetChange: this.onTargetChange.bind(this),
            onTargetFocus: this.onTargetFocus.bind(this),
            multiple: false,
        };

        const defaultTargetProps = {
            targetData: [],
            targetValues: this.state.targetList,
            title: '维修人员',
            targetCount: this.state.targetCount,
            onTargetChange: this.onTargetChange.bind(this),
            onTargetFocus: this.onTargetFocus.bind(this),
            multiple: false,
        };

        const {maDetailsList} = this.state;

        return (
            <div className='phone-select-root' style={{height: '100%', maxHeight: '100vh'}} ref={node => this.node = node} onChange={this.handelValueCom}>
                <div className="model">
                    <div className="myModelDetails">

                        <div className="modelTitleDetails">
                            <div className="modelTitle">标题</div>
                            <div className="modelContent">物业维修</div>
                        </div>
                        <div className="modelTitleDetails">
                            <div className="modelTitle">发起人</div>
                            <div className="modelContent1">{maDetailsList.maProposerName}</div>
                        </div>
                        <div className="modelTitleDetails">
                            <div className="modelTitle">发起电话</div>
                            <div className="modelContent1">{maDetailsList.maProposerPhone}</div>
                        </div>
                        <div className="modelTitleDetails">
                            <div className="modelTitle">发起时间</div>
                            <div className="modelContent1">{maDetailsList.maRepairsTime}</div>
                        </div>
                        <div className="modelTitleDetails">
                            <div className="modelTitle">工单编号</div>
                            <div className="modelContent1">{maDetailsList.maNumber}</div>
                        </div>
                        <div className="modelTitleDetails">
                            <div className="modelTitle">处理状态</div>
                            <div className="modelContent1">
                                {maDetailsList.maState === 0 ? <div className = "taskBtnoverdue">待分配</div> :
                                    maDetailsList.maState === 1 ? <div className = "taskBtn">维修中</div>:
                                        <div className = "taskBtn">已处理</div>}
                            </div>
                        </div>
                        <div className="modelTitleDetails">
                            <div className="modelTitle">维修地点</div>
                            <div className="modelContent1">{maDetailsList.maRepairSite}</div>
                        </div>
                        <div className="modelTitleDetails">
                            <div className="modelTitle">故障描述</div>
                            <div className="modelContent1">{maDetailsList.maFaultReason}</div>
                        </div>

                        <div className="myModelDetailsBottom"></div>

                        {maDetailsList.maState === 0 ? (this.state.targetData.length > 0 ?
                            <TargetSelect {...targetProps}/>
                            : <TargetSelect {...defaultTargetProps}/>) :
                            <div className="modelTitleDetails">
                                <div className="modelTitle">维修人员</div>
                                <div className="modelContent1">{maDetailsList.miPeopleName}</div>
                            </div>
                        }
                        {maDetailsList.maState === 0 ?
                            <DatePicker
                                value={this.state.scrapTime}
                                locale={{
                                    okText: '确定',
                                    dismissText: '取消'
                                }}
                                onChange={date => this.setState({scrapTime: date})}>
                                <List.Item arrow="horizontal"><div className="modelTitleDetails">计划日期</div></List.Item>
                            </DatePicker> :
                        <div className="modelTitleDetails">
                              <div className="modelTitle">计划时间</div>
                              <div className="modelContent1">{maDetailsList.mdPlanTime}</div>
                        </div>
                        }
                        {maDetailsList.maState === 2 ?
                        <div className="modelTitleDetails">
                            <div className="modelTitle">实际时间</div>
                            <div className="modelContent1">{maDetailsList.miPerfectTime}</div>
                        </div> : ''
                        }
                        <div className="modelTitleDetails">
                            {maDetailsList.maState === 0 ? '' :
                            <div className="modelTitle">维修详情</div>}
                            {maDetailsList.maState === 1 ?
                                <div className="modelContent1">
                                    <textarea ref='repairDetails' className="form-control textarea_sty" rows="4"
                                               placeholder="维修描述" maxLength={100}></textarea>
                                </div> :
                                <div className="modelContent1">{maDetailsList.miDetails}</div>}
                        </div>
                    </div>
                    {maDetailsList.maState === 1 ?
                    <UploadEnclosure
                        action={API.UPLOAD_FILE}
                        fileList={this.state.fileList}
                        count={9}
                        multiple={true}
                        beforeUpload={this.beforeUpload.bind(this)}
                        handleChange={this.handleChange.bind(this)}
                    /> : ''}
                    {
                        this.state.imageMaList.length != 0 && JSON.parse(this.state.imageMaList).length != 0 && maDetailsList.maState === 0 ? <div style={{marginLeft: "15px"}}>报修申请附件</div> : (this.state.imageMaList.length != 0 && JSON.parse(this.state.imageMaList).length != 0 && maDetailsList.maState !== 0 ? <div className='modelTitle1'>报修申请附件</div> : '')
                    }
                    <div className='flex' style={{marginTop: '8px'}}>
                        {this.state.previewVisible0 ?
                            <ImagesViewer onClose={this.handleCancel0} urls={JSON.parse(this.state.imageMaList)}
                                          index={0}
                                          needPoint={JSON.parse(this.state.imageMaList).length <= 9}/> : ""}
                        {
                            this.state.imageMaList.length != 0 && JSON.parse(this.state.imageMaList).length != 0 ?
                                JSON.parse(this.state.imageMaList).map((item, index)=>{
                                    return(<img style={{marginLeft: "8px"}} key={index}
                                                onClick={this.onClickImage0.bind(this)}
                                                 src={item}
                                                 width={100}
                                                 height={100}/>)
                                }) : ''
                        }
                    </div>

                    {
                        this.state.imageMiList.length != 0 && JSON.parse(this.state.imageMiList).length != 0 ? <div className='modelTitle1'>维修完成附件</div> : ''
                    }
                    <div className='flex' style={{marginTop: '8px'}}>
                        {this.state.previewVisible1 ?
                            <ImagesViewer onClose={this.handleCancel1} urls={JSON.parse(this.state.imageMiList)}
                                          index={0}
                                          needPoint={JSON.parse(this.state.imageMiList).length <= 9}/> : ""}
                        {
                            this.state.imageMiList.length != 0 && JSON.parse(this.state.imageMiList).length != 0 ?
                                JSON.parse(this.state.imageMiList).map((item, index)=>{
                                    return(<img style={{marginLeft: "8px"}} key={index}
                                                onClick={this.onClickImage1.bind(this)}
                                                src={item}
                                                width={100}
                                                height={100}/>)
                                }) : ''
                        }
                    </div>
                </div>
            </div>
        )
    }

    onTargetChange = (value, label, checkNodes, count) => {
        this.checkNodes = checkNodes;
        this.setState({
            targetList: value,
            targetCount: count
        });
    };

    getOrganization = () => {
        Toast.loading('', 0);

        fetchGet(API.getRepair, {
            schoolId: this.props.userInfo.teacher.schoolId,
            // schoolId:1
        }).then(response => {
            Toast.hide();
            const {targetData} = this.state;
            targetData.length = 0;
            if (response && response.data) {
                // const schoolArray = response.data.schools
                const propertyArray = response.data;

                if (!isObjEmpty(propertyArray)) {
                    const propertyData = [];
                    propertyArray.forEach((hrObj, index) => {
                        if (hrObj) {
                            propertyData.push({
                                title: getStrValue(hrObj, 'name'),
                                mpId: getIntValue(hrObj, 'id'),
                                teacherId: getIntValue(hrObj, 'teacherId'),
                                userPhone: getStrValue(hrObj, 'phone'),
                                value: getStrValue(hrObj, 'name') + `-0-${index}`,
                                key: `0-${index}`,
                            })
                        }
                    });

                    targetData.push({
                        title: `全体物业维修人员`,
                        value: `0`,
                        key: `0`,
                        selectable:false,
                        children: propertyData,
                    })
                }
            }

            this.setState({
                targetData,
            })
        }).catch(error => {
            Toast.hide();

            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
        })
    };

    onTargetFocus = (e) => {
        if (isObjEmpty(this.state.targetData)) {
            this.getOrganization()
        }
    };

    beforeUpload = (file, fileList) => {

    };

    handleChange = fileList => {
        if (fileList) {
            this.setState({fileList})
        }
    };

    loadPhones = () => {
        try {
            this.setState({
                isRefreshing: true
            })
        } catch (e) {
        }

        if (this.mType == 'maintenance') {
            this.url = API.GET_MAINTENANCE_DETAILS;
            this.params = {
                maId: this.maId
            };
            this.getPhones()
        } else {
            Toast.hide();
            this.setState({
                isRefreshing: false
            })
        }
    };

    getPhones = () => {
        mPageIndex++;

        const {maDetailsList, searchKey} = this.state;
        // if (mPageIndex === 1) {
        //     maDetailsList.length = 0
        // }
        fetchPost(this.url, {
            pageIndex: mPageIndex,
            pageSize: mPageSize,
            selectKey: searchKey,
            ...this.params
        }).then(response => {
            Toast.hide();

            if (response && response.data) {
                if (this.mType == 'maintenance') {
                    {console.log(response.data)}

                    maDetailsList.maId = getIntValue(response.data, 'id');
                    maDetailsList.maProposer = getIntValue(response.data, 'proposer');
                    maDetailsList.maProposerName = getStrValue(response.data, 'proposerName');
                    maDetailsList.maProposerPhone = getStrValue(response.data, 'proposerPhone');
                    maDetailsList.maSchoolId = getIntValue(response.data, 'schoolId');
                    maDetailsList.maType = getIntValue(response.data, 'type');
                    maDetailsList.maRepairsTime = getStrValue(response.data, 'repairsTime');
                    maDetailsList.maRepairSite = getStrValue(response.data, 'repairSite');
                    maDetailsList.maFaultReason = getStrValue(response.data, 'faultReason');
                    maDetailsList.maState = getIntValue(response.data, 'state');
                    maDetailsList.maPicture = getStrValue(response.data, 'picture');
                    maDetailsList.maEntryTime = getStrValue(response.data, 'entryTime');
                    maDetailsList.maNotifier = getStrValue(response.data, 'notifier');
                    maDetailsList.maNumber = getStrValue(response.data, 'number');

                    this.setState({
                        imageMaList:maDetailsList.maPicture
                    },()=>{
                        /*console.log("------------------------------")
                        console.log(this.state.imageList)
                        console.log(JSON.parse(this.state.imageList))*/
                    });
                    maDetailsList.miHrId = getIntValue(response.data, 'mi_hrid');
                    maDetailsList.miPeopleName = getStrValue(response.data, 'mi_peopleName');
                    maDetailsList.miPerfectTime = getStrValue(response.data, 'mi_perfectTime');
                    maDetailsList.miPicture = getStrValue(response.data, 'mi_picture');
                    maDetailsList.miDetails = getStrValue(response.data, 'mi_details');

                    this.setState({
                        imageMiList:maDetailsList.miPicture
                    },()=>{});
                    maDetailsList.mdPlanTime = getStrValue(response.data, 'md_planTime')
                }
            } else {
                if (mPageIndex > 1) {
                    mPageIndex--
                }
            }

            this.setState({
                maDetailsList,
                isLoading: false,
                isRefreshing: false,
            })
        }).catch(error => {
            Toast.hide();

            if (mPageIndex > 1) {
                mPageIndex--
            }
            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常')
            }

            this.setState({
                isLoading: false,
                isRefreshing: false,
            })
        })
    };

    handelValueCom = (event) => {

        let repairDetails = this.refs.repairDetails.value;
        //获得内容的值
        this.setState({
            repairDetails: repairDetails,
        })
    }
}

let mapStateToProps = (state) => ({
    userInfo: {...state.redUserInfo},
});

let mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ManagementDetail)